import React from "react";
import { Row, Col } from "antd";



const SimpleHeader = ({ title, subtitle }) => {

    return (
        <Row gutter={24} align="middle">
            <Col xl={24} lg={24} md={24} sm={0} xs={0} className="text-left">
                <h3 className="m-0">
                    {title}
                </h3>
            </Col>
            <Col xl={0} lg={0} md={0} sm={24} xs={24} className="text-left">
                <h4 className="m-0">
                    {subtitle}
                </h4>
            </Col>
        </Row>
    );
};


export default SimpleHeader;